var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"preloader"},[_c('img',{attrs:{"src":require('../assets/img/loader_5.webp')}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }